var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g, _rect, _path116, _path117;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 100,
    viewBox: "0 0 240 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.407 94.5312C145.407 94.5312 145.407 78.3632 164.547 72.6689C183.687 66.9746 179.13 37.3187 203.054 41.8814C226.979 46.4438 215.359 76.7836 224.7 83.3991C234.042 90.015 231.992 94.5312 231.992 94.5312H145.407Z",
    fill: "#70A9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.339 54.9191C86.2215 54.3063 84.7131 54.9531 83.6484 56.3457L87.4322 60.1562L88.339 54.9191Z",
    fill: "#4060A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6484 85.1562L86.2166 84.3078C86.2166 84.3078 87.7097 80.5863 89.1208 75.7812L85.0602 76.3442L83.6484 85.1562Z",
    fill: "#4060A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.085 75V85.1562L83.0387 84.8438L84.4302 76.2369L82.085 75Z",
    fill: "#4060A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5872 65.625L87.5573 60.0928L83.6927 56.25C82.9109 57.4299 82.4025 59.0515 82.085 60.8562V62.2939L86.5872 65.625Z",
    fill: "#4060A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2119 75L89.4672 74.4773C89.8991 73.1487 90.3193 71.7397 90.6842 70.3125L85.9471 70.9319L85.2119 75Z",
    fill: "#4060A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9938 65.7663L82.085 62.5V68.3147L85.2881 70.3125L85.9938 65.7663Z",
    fill: "#4060A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4654 57.9462C90.9593 56.3943 90.0097 55.2324 88.453 54.6875L87.5566 59.375L91.4654 57.9462Z",
    fill: "#4060A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7754 65.625L92.072 64.5689C92.3335 62.3469 92.326 60.279 91.8932 58.5938L87.7701 60.1736L86.7754 65.625Z",
    fill: "#4060A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8691 80.4688L81.3029 77.3902V71.0938L76.6123 75.2031L77.8691 80.4688Z",
    fill: "#4060A9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9932 70.3125L90.6165 69.6467C90.98 68.0325 91.28 66.4045 91.4655 64.8438L86.7185 65.8955L85.9932 70.3125Z",
    fill: "#4060A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.212 70.6504L82.085 68.75V73.6977L84.519 75L85.212 70.6504Z",
    fill: "#4060A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6812 70.1094L64.8857 69.5312C65.2917 71.3669 65.8126 73.2081 66.4367 75L75.8304 74.6353L74.6812 70.1094Z",
    fill: "#4060A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8883 63.7174L64.1045 62.5C64.2201 64.5713 64.5034 66.7487 64.9374 68.9416L74.2674 69.5312L72.8883 63.7174Z",
    fill: "#4060A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0972 48.4375C66.4892 49.0889 64.8761 51.5689 64.1045 55.0549L71.1403 57.0312L69.0972 48.4375Z",
    fill: "#4060A9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1081 63.2812L80.5207 56.6116C79.9686 55.0251 79.252 53.5642 78.3285 52.3438L72.7031 57.5027L74.1081 63.2812Z",
    fill: "#4060A9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3933 75.7812L66.4492 76.1536C67.0397 77.9221 67.7229 79.6371 68.4866 81.25L76.6121 80.9303L75.3933 75.7812Z",
    fill: "#4060A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5762 81.5475C70.7755 83.8225 72.1642 85.8638 73.7074 87.5L78.9573 85.9756L77.7469 81.25L69.5762 81.5475Z",
    fill: "#4060A9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8726 74.2188L81.3034 70.2321V64.8438L75.8311 69.7363L76.8726 74.2188Z",
    fill: "#4060A9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6153 69.5312L81.3034 64.4673V60.4731C81.0897 59.297 80.8171 58.1374 80.4722 57.0312L74.2676 63.7562L75.6153 69.5312Z",
    fill: "#4060A9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1758 80.9691L79.3448 85.9375L81.3028 85.3187V78.125L78.1758 80.9691Z",
    fill: "#4060A9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.176 51.7937C76.7503 50.0565 74.8816 48.845 72.4351 48.5096C71.6863 48.4064 70.9961 48.417 70.3584 48.5223L72.4372 57.0312L78.176 51.7937Z",
    fill: "#4060A9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3318 57.4109L64.5367 55.4688C64.1576 57.4179 64.0345 59.6693 64.1415 62.077L72.7038 63.2812L71.3318 57.4109Z",
    fill: "#4060A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4093 81.3881L78.1758 81.3977L79.358 86.7188L79.7393 86.5907L78.5527 81.25L78.4093 81.3881Z",
    fill: "#577BC2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.753 57.0312L71.9214 56.8688L69.9693 48.4375C69.8357 48.4611 69.7049 48.4901 69.5762 48.5233L71.5316 56.9673L71.753 57.0312Z",
    fill: "#577BC2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1758 80.2789L76.9862 75L76.8425 75.1332L76.6123 75.1434L77.8122 80.4688L77.9835 80.4619L78.1758 80.2789Z",
    fill: "#577BC2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6123 74.0418L75.4573 69.5312L75.2921 69.6653L75.0488 69.6511L76.2184 74.2188L76.4045 74.2119L76.6123 74.0418Z",
    fill: "#577BC2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2666 63.0786L73.0476 57.0312L72.8982 57.1963L72.7031 57.1319L73.9374 63.2535L74.1052 63.2812L74.2666 63.0786Z",
    fill: "#577BC2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0489 69.3604L73.8258 63.2812L73.6953 63.4457L73.4854 63.4112L74.7141 69.5188L74.8831 69.5312L75.0489 69.3604Z",
    fill: "#577BC2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7226 65.625L85.2119 70.1997L85.3421 70.3125L85.4836 70.2825L85.9937 65.7125L85.8405 65.7622L85.7226 65.625Z",
    fill: "#577BC2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9368 70.3125L84.4297 74.8995L84.5596 75L84.7055 74.9703L85.2114 70.3921L85.0639 70.4235L84.9368 70.3125Z",
    fill: "#577BC2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0083 59.375L87.2811 59.2942L88.3389 54.8121C88.1835 54.7679 88.025 54.7267 87.8591 54.6913C87.8529 54.6898 87.8472 54.689 87.841 54.6875L86.7754 59.2028L87.0083 59.375Z",
    fill: "#577BC2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.257 76.6563L84.0991 76.5625L82.8662 85.1562L83.2253 85.0237L84.4297 76.6296L84.257 76.6563Z",
    fill: "#577BC2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0804 60.1562L85.9932 65.4796L86.2221 65.625L86.4645 65.5819L87.5567 60.2339L87.2822 60.3283L87.0804 60.1562Z",
    fill: "#577BC2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0303 56.5762L64.1888 54.6875C64.1595 54.8193 64.1318 54.9535 64.1045 55.0882L71.1403 57.0312L71.0303 56.5762Z",
    fill: "#577BC2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8082 57.0312L78.1754 51.883C78.0964 51.774 78.0158 51.667 77.9341 51.5625L72.7031 56.5797L72.8082 57.0312Z",
    fill: "#577BC2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9214 57.6105L71.7515 57.0312L71.4871 57.2322L71.1396 57.1528L71.3096 57.7332L71.6564 57.8125L71.9214 57.6105Z",
    fill: "#577BC2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3773 62.8721L64.1045 61.7188C64.1109 61.8512 64.1186 61.9837 64.1267 62.1169L73.4856 63.2812L73.3773 62.8721Z",
    fill: "#577BC2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3765 63.2812L80.5216 56.6791C80.4765 56.5346 80.4291 56.3925 80.3812 56.25L74.2676 62.8188L74.3765 63.2812Z",
    fill: "#577BC2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2671 63.868L74.0861 63.2812L73.7918 63.5227L73.4854 63.4901L73.6489 64.0218L74.0304 64.0625L74.2671 63.868Z",
    fill: "#577BC2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1633 69.5312L81.3029 64.5966V64.0625L75.0488 69.0888L75.1633 69.5312Z",
    fill: "#577BC2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1685 69.2076L64.8857 68.75C64.9128 68.8575 64.9411 68.9649 64.9697 69.0727L74.2668 69.5312L74.1685 69.2076Z",
    fill: "#577BC2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8306 70.1305L75.6585 69.5312L75.3566 69.7501L75.0488 69.7336L75.2092 70.2933L75.5793 70.3125L75.8306 70.1305Z",
    fill: "#577BC2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5208 73.9283L81.8664 73.5648L82.0845 73.6204V68.7789L81.5029 68.6102L81.8844 68.2561L82.0845 68.3137V62.7802L81.4591 62.5368L81.9281 62.2123L82.0845 62.2736V60.9066C81.9883 61.1946 81.9008 61.4867 81.8234 61.7836C81.6733 61.2401 81.5005 60.6965 81.3027 60.1562V64.1183L81.4395 64.0579L81.9477 64.3662L81.3027 64.6521V70.083L81.4388 70.0221L81.9485 70.3296L81.3027 70.6184V76.6346L81.4356 76.5737L81.9524 76.8779L81.3027 77.1748V84.375L82.0845 84.2505V74.0723L81.5208 73.9283Z",
    fill: "#577BC2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0161 64.4678L81.5079 64.0625L81.3711 64.1425V64.8438L82.0161 64.4678Z",
    fill: "#577BC2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6408 59.7747L87.5566 60.1562L91.4654 58.9141C91.4319 58.8054 91.3959 58.6981 91.3566 58.5938L87.6408 59.7747Z",
    fill: "#577BC2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5572 59.6756L83.899 56.25C83.8126 56.3553 83.7288 56.4649 83.6484 56.5793L87.4679 60.1562L87.5572 59.6756Z",
    fill: "#577BC2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6949 60.1562L87.5566 60.7366L87.8311 60.9375L88.2055 60.8272L88.3384 60.2714L87.9912 60.373L87.6949 60.1562Z",
    fill: "#577BC2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7754 66.4062L91.4193 65.3005C91.4363 65.1471 91.4509 64.9959 91.4659 64.8438L86.8463 65.9434L86.7754 66.4062Z",
    fill: "#577BC2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9938 65.9215L82.085 62.5V63.0475L85.922 66.4062L85.9938 65.9215Z",
    fill: "#577BC2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1216 65.625L85.9932 66.2305L86.2795 66.4062L86.6512 66.3427L86.7749 65.7613L86.4388 65.8188L86.1216 65.625Z",
    fill: "#577BC2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6322 62.5L82.1631 62.9467L82.7885 63.2812V62.5838L82.6322 62.5Z",
    fill: "#577BC2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.212 70.6665L82.085 68.75V69.219L85.1444 71.0938L85.212 70.6665Z",
    fill: "#577BC2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9932 70.3125L90.5849 69.8402C90.6184 69.7375 90.6511 69.6345 90.6837 69.5312L86.0636 70.0068L85.9932 70.3125Z",
    fill: "#577BC2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3337 70.3125L85.2119 70.941L85.518 71.0938L85.8732 71.0504L85.9937 70.4286L85.6499 70.4707L85.3337 70.3125Z",
    fill: "#577BC2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5665 68.75L82.185 69.2791L82.7667 69.5312V68.8367L82.5665 68.75Z",
    fill: "#577BC2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4297 76.5625L88.975 76.1267C89.0234 76.0123 89.0718 75.8969 89.1202 75.7812L84.5084 76.2236L84.4297 76.5625Z",
    fill: "#577BC2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.085 75V75.4174L84.3648 76.5625L84.4302 76.1777L82.085 75Z",
    fill: "#577BC2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5491 75.7812L84.4297 76.418L84.7457 76.5625L85.0913 76.521L85.2114 75.8817L84.8612 75.9232L84.5491 75.7812Z",
    fill: "#577BC2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5396 74.2188L82.194 74.7779L82.7577 75V74.3049L82.5396 74.2188Z",
    fill: "#577BC2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7305 74.2188L66.4492 74.5933C66.4944 74.7289 66.5391 74.8648 66.5855 75L75.8303 74.6271L75.7305 74.2188Z",
    fill: "#577BC2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7207 75L81.3029 70.8746V70.3125L76.6123 74.5346L76.7207 75Z",
    fill: "#577BC2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3941 74.8158L77.219 74.2188L76.8986 74.4484L76.6123 74.4582L76.7702 75L77.1545 74.9869L77.3941 74.8158Z",
    fill: "#577BC2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0165 70.7153L81.5068 70.3125L81.3707 70.3928V71.0938L82.0165 70.7153Z",
    fill: "#577BC2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2772 81.25L81.3028 78.6235V78.125L78.1758 80.8391L78.2772 81.25Z",
    fill: "#577BC2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0745 81.25L69.5762 81.5949C69.6433 81.7405 69.7095 81.887 69.7774 82.0312L78.1755 81.6899L78.0745 81.25Z",
    fill: "#577BC2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4614 80.7024L78.1758 80.7116L78.335 81.25L78.7206 81.2375L78.9575 81.0653L78.7818 80.4688L78.4614 80.7024Z",
    fill: "#577BC2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0184 77.7394L81.5017 77.3438L81.3688 77.4223V78.125L82.0184 77.7394Z",
    fill: "#577BC2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.447 95.3125C109.447 95.3125 106.505 75.5085 88.6862 72.4628C70.8674 69.4179 73.023 44.3437 48.6764 45.3415C24.3299 46.3397 29.3469 69.6676 19.6586 74.907C9.9706 80.146 5.47266 95.3125 5.47266 95.3125H109.447Z",
    fill: "#70A9FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5921 96.0812L13.2899 96.0938L0.63017 49.2188C-3.31996 50.8566 12.5921 96.0812 12.5921 96.0812",
    fill: "#9DADEC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1616 96.0938L29.7064 60.4705C26.4558 60.3132 22.2516 74.2421 20.293 81.4648C19.6348 84.0726 19.1988 85.6905 19.1988 85.6905C19.1988 85.6905 19.6092 83.9867 20.293 81.4648C22.9279 71.0294 29.1448 44.686 25.4267 42.1875L15.6348 96.0671L17.1616 96.0938Z",
    fill: "#9DADEC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0721 96.0938L12.9872 32.8125C8.59061 35.8407 12.4341 87.7575 12.4341 87.7575C12.4341 87.7575 4.95705 50.4573 0.782227 49.4597L13.5631 96.085L14.0721 96.0938Z",
    fill: "#9DADEC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3257 81.25C19.8371 83.581 19.5439 85.1562 19.5439 85.1562C19.5439 85.1562 19.8554 83.6605 20.3257 81.25",
    fill: "#9DADEC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1304 96.0938L25.0164 42.5053C19.8455 41.6248 15.1169 87.7593 15.1169 87.7593C15.1169 87.7593 18.5426 32.8125 13.3031 32.8125C13.2985 32.8125 13.2947 32.8146 13.29 32.8146L14.4183 96.0818L15.1304 96.0938Z",
    fill: "#9DADEC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1475 96.0938C20.1475 96.0938 35.6473 62.5842 31.2755 60.1959C31.2455 60.1794 31.2154 60.1702 31.185 60.1562L18.7627 96.0693L20.1475 96.0938Z",
    fill: "#9DADEC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0721 96.0938L1.1997 49.2395C1.06506 49.2074 0.934111 49.212 0.806856 49.2574C0.797826 49.2603 0.790847 49.2674 0.782227 49.2712L13.644 96.0858L14.0721 96.0938Z",
    fill: "#607ED5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8536 96.0938L13.7147 32.8125C13.5654 32.8154 13.4245 32.8642 13.29 32.9524L14.4267 96.0863L14.8536 96.0938Z",
    fill: "#607ED5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.058 96.0938L25.7976 42.3465C25.7274 42.2986 25.6539 42.2591 25.5762 42.2287C25.5181 42.2066 25.4601 42.1975 25.402 42.1875L15.6348 96.0863L16.058 96.0938Z",
    fill: "#607ED5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 96.0938L29.7064 60.256C29.5762 60.1962 29.444 60.1626 29.3102 60.1562L17.1982 96.0858L17.6253 96.0938Z",
    fill: "#607ED5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.297 96.0938L232.182 42.5053C227.011 41.6261 222.283 87.7593 222.283 87.7593C222.283 87.7593 225.709 32.8125 220.47 32.8125C220.465 32.8125 220.461 32.8146 220.456 32.8146L221.584 96.0818L222.297 96.0938Z",
    fill: "#9DADEC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.329 96.0938L236.873 60.4705C233.623 60.3124 229.419 74.2417 227.46 81.4648C226.801 84.0726 226.366 85.6905 226.366 85.6905C226.366 85.6905 226.776 83.9867 227.46 81.4648C230.095 71.029 236.312 44.6852 232.593 42.1875L222.802 96.0671L224.329 96.0938Z",
    fill: "#9DADEC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.71 81.25C226.222 83.581 225.929 85.1562 225.929 85.1562C225.929 85.1562 226.24 83.6605 226.71 81.25",
    fill: "#9DADEC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.75 96.0938C225.75 96.0938 241.25 62.5842 236.878 60.1959C236.848 60.1794 236.818 60.1702 236.788 60.1562L224.365 96.0689L225.75 96.0938Z",
    fill: "#9DADEC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.195 96.0812L218.892 96.0938L206.233 49.2188C202.283 50.857 218.195 96.0812 218.195 96.0812",
    fill: "#9DADEC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.456 96.0938L219.371 32.8125C214.974 35.8407 218.818 87.7575 218.818 87.7575C218.818 87.7575 211.341 50.4573 207.166 49.4597L219.946 96.085L220.456 96.0938Z",
    fill: "#9DADEC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.675 96.0938L206.802 49.2395C206.668 49.2074 206.537 49.212 206.409 49.2574C206.4 49.2603 206.393 49.2674 206.385 49.2712L219.247 96.0858L219.675 96.0938Z",
    fill: "#607ED5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.237 96.0938L220.099 32.8125C219.949 32.8154 219.808 32.8642 219.674 32.9524L220.811 96.0863L221.237 96.0938Z",
    fill: "#607ED5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.443 96.0938L232.182 42.3465C232.112 42.2986 232.038 42.2591 231.961 42.2287C231.902 42.2066 231.844 42.1975 231.786 42.1875L222.02 96.0863L222.443 96.0938Z",
    fill: "#607ED5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.792 96.0938L236.873 60.256C236.743 60.1958 236.611 60.1626 236.478 60.1562L224.365 96.0862L224.792 96.0938Z",
    fill: "#607ED5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9248 53.125L38.9468 95.3125L39.7466 95.3059L42.2045 82.9267C42.3293 77.9272 41.5026 63.4515 28.9248 53.125",
    fill: "#5080CC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7141 95.3125L32.0517 95.2748L14.0713 75C18.5753 91.0133 27.7141 95.3125 27.7141 95.3125",
    fill: "#5080CC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8535 74.2188L33.254 95.3125L34.3975 95.3026L28.7089 83.4612C26.5764 80.1296 22.0491 74.7494 14.8535 74.2188",
    fill: "#5080CC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8231 82.5596L35.1074 95.3125L38.306 95.285L28.2061 53.125C23.5377 64.7153 26.7304 76.816 28.8231 82.5596",
    fill: "#5080CC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5361 95.2748C46.5361 95.2748 60.7266 89.7492 60.9771 67.9688L42.2148 95.3125L46.5361 95.2748Z",
    fill: "#5080CC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2507 83.0452L39.8701 95.3125L41.9803 95.2935L60.9776 67.1875C47.5535 72.9296 43.4406 80.0313 42.2507 83.0452",
    fill: "#5080CC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0713 74.2188C14.1198 74.3986 14.1716 74.5697 14.2209 74.7467L32.2928 95.3125L32.8335 95.3076L14.3217 74.2414C14.2373 74.2348 14.1561 74.2237 14.0713 74.2188",
    fill: "#65A3FA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3228 52.3438C28.261 52.4973 28.2029 52.6509 28.1436 52.8053L37.8898 95.3125L38.3064 95.3087L28.4878 52.486C28.4325 52.4388 28.3789 52.3905 28.3228 52.3438",
    fill: "#65A3FA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8228 67.2567L42.2148 95.3125L42.7097 95.3079L60.9714 67.7748C60.9738 67.5794 60.9771 67.3858 60.9771 67.1875C60.924 67.2103 60.8754 67.2339 60.8228 67.2567",
    fill: "#65A3FA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7486 86.052C30.9151 86.4137 31.0097 86.6043 31.0097 86.6043C31.0097 86.6043 30.9222 86.4059 30.7486 86.052",
    fill: "#577BC2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2663 85.8729C30.358 86.0581 30.4043 86.162 30.4043 86.162C30.4043 86.162 30.3543 86.0622 30.2663 85.8729C30.059 85.4542 29.615 84.6101 28.9248 83.56L34.7212 95.3125L35.1789 95.3084L29.0157 82.8125C29.5683 84.3284 30.0425 85.3928 30.2663 85.8729",
    fill: "#577BC2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7038 84.6115C41.7038 84.6115 41.7896 83.9573 41.821 82.8125L39.0879 95.3125L39.5589 95.3092L42.2149 83.1599C41.809 84.0728 41.7038 84.6115 41.7038 84.6115",
    fill: "#577BC2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.953 86.3431L205.152 96.0938H206.242L212.638 52.3438C201.428 63.7109 201.973 79.2566 202.953 86.3431",
    fill: "#4060A9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.404 65.625L204.322 96.0938H204.821L202.462 85.0857C200.594 79.3721 196.467 70.1534 188.404 65.625",
    fill: "#4060A9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.563 96.0938H204.039L187.622 66.4062C187.79 89.3937 201.563 96.0938 201.563 96.0938",
    fill: "#4060A9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.235 96.0938C215.235 96.0938 226.316 90.8612 231.4 73.4375L213.42 96.0938H215.235Z",
    fill: "#4060A9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.284 87.1893L211.856 96.0938H212.639L231.4 73.4375C222.482 76.1415 217.575 82.9253 215.284 87.1893",
    fill: "#4060A9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.311 52.3438L207.166 96.0938H210.928L214.224 86.8519C216.039 80.0395 218.798 65.3021 213.311 52.3438",
    fill: "#4060A9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.622 65.625C187.622 65.769 187.625 65.9095 187.626 66.0522L203.575 96.0938H204.039L187.962 65.8117C187.85 65.7495 187.737 65.686 187.622 65.625",
    fill: "#577BC2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.15 52.3438C213.119 52.3741 213.09 52.4044 213.058 52.4351L206.385 96.0938H206.821L213.421 52.9224C213.332 52.7293 213.243 52.5361 213.15 52.3438",
    fill: "#577BC2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.12 73.5281L212.639 96.0938H213.168L231.21 74.0643C231.273 73.8547 231.339 73.6511 231.401 73.4375C231.305 73.4658 231.214 73.499 231.12 73.5281",
    fill: "#577BC2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.707 88.9969C203.885 89.6624 203.963 90.0421 203.963 90.0421C203.963 90.0421 203.858 89.6721 203.707 88.9969C203.478 88.1347 203.082 86.7902 202.476 85.1562L205.137 96.0938H205.603L203.189 86.1785C203.368 87.3748 203.559 88.3336 203.707 88.9969",
    fill: "#577BC2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.428 89.0625C203.688 89.5672 203.869 89.8438 203.869 89.8438C203.869 89.8438 203.734 89.5599 203.428 89.0625",
    fill: "#577BC2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.8 89.8465C212.632 90.3363 212.532 90.5993 212.532 90.5993C212.532 90.5993 212.619 90.3222 212.8 89.8465C213.024 89.1884 213.37 88.1173 213.756 86.7188L210.293 96.0938H210.744L214.202 86.7333C213.512 88.0704 213.057 89.167 212.8 89.8465",
    fill: "#577BC2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.277 90.625C212.943 91.1187 212.782 91.4062 212.782 91.4062C212.782 91.4062 212.967 91.1333 213.277 90.625",
    fill: "#577BC2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_909_57012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 83,
    width: 239,
    height: 17
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02246 83.739H239.896V100H1.02246V83.739Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_909_57012)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.459 83.739C36.4029 83.739 1.02246 95.1881 1.02246 95.1881C1.02246 95.1881 36.4029 100 120.459 100C204.516 100 239.896 95.1881 239.896 95.1881C239.896 95.1881 204.516 83.739 120.459 83.739",
    fill: "#CFE6FD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.935,
    width: 5.47231,
    height: 89.0625,
    rx: 1,
    fill: "#CFE6FD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.663 4.18484C108.85 4.00608 109.098 3.90625 109.356 3.90625H141.28C141.833 3.90625 142.28 4.35397 142.28 4.90625V16.9688C142.28 17.521 141.833 17.9688 141.28 17.9688H109.356C109.098 17.9688 108.85 17.8689 108.663 17.6902L102.38 11.6589C101.97 11.2653 101.97 10.6097 102.38 10.2161L108.663 4.18484Z",
    fill: "#CFE6FD"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.369 19.1871C164.183 18.9136 163.873 18.75 163.542 18.75H143.281C142.728 18.75 142.281 19.1977 142.281 19.75V31.8125C142.281 32.3648 142.728 32.8125 143.281 32.8125H163.542C163.873 32.8125 164.183 32.6489 164.369 32.3754L168.477 26.3442C168.708 26.0046 168.708 25.5579 168.477 25.2183L164.369 19.1871Z",
    fill: "#6AA5FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionImage);
export default __webpack_public_path__ + "static/media/action_image.4ef8808f4819992a1e8f1f742b4f8195.svg";
export { ForwardRef as ReactComponent };